import React, { useEffect, useState } from "react"

import PropTypes from "prop-types"

import "../../../Reports/components/SummaryWidgets/index.less"
import { MEASUREMENT_WIDGET_TYPE } from "../../../utils/constants"
import WidgetResponseRateReport from "../WidgetResponseRateReport"
import WidgetListOutcomes from "../WidgetListOutcomes"
import WidgetChartEnps from "../WidgetChartEnps"
import WidgetListDimensions from "../WidgetListDimensions"
import WidgetErrorBoundary from "../../../components/WidgetErrorBoundary"
import {
  isAmbassadorOrLeaderActive,
} from "../../../utils/storage"

export function SummaryWidgets(props) {
  const [typeMeasureWidget, setTypeMeasureWidget] = useState(null)

  const resetKey = `${props.idMeasure}-${props.idDivisionSelected}-${props.selectedSegment}`

  useEffect(() => {
    const { measureGeneral } = props
    // Mientras measureGeneral sea de otra medición (la anterior) no se decide qué widgets mostrar
    if (!measureGeneral || measureGeneral.id_measure !== props.idMeasure) {
      setTypeMeasureWidget(null)
      return
    }
    switch (measureGeneral.is_engagement) {
      case true:
        if (measureGeneral.has_enps) {
          if (measureGeneral.is_enps_engagement) {
            setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.enpsAndEngagement)
          } else {
            setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.onlyEnps)
          }
        } else {
          setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.onlyEngagement)
        }
        break

      case false:
        setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.leadershipOrClimate)
        break
    }
  }, [props.idMeasure, props.measureGeneral?.id_measure])

  const renderWidgetResumeEnps = (typeMeasureWidget) => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (
      ![
        MEASUREMENT_WIDGET_TYPE.enpsAndEngagement,
        MEASUREMENT_WIDGET_TYPE.onlyEnps,
        MEASUREMENT_WIDGET_TYPE.leadershipOrClimate,
      ].includes(typeMeasureWidget)
    ) {
      return null
    }

    if (!measureGeneral.has_enps) {
      return null
    }

    return (
      <WidgetErrorBoundary resetKey={resetKey}>
        <WidgetChartEnps
          idMeasure={idMeasure}
          measureGeneral={measureGeneral}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
      </WidgetErrorBoundary>
    )
  }

  const renderWidgetResumeOutcomes = () => {
    if (
      ![
        MEASUREMENT_WIDGET_TYPE.enpsAndEngagement,
        MEASUREMENT_WIDGET_TYPE.onlyEnps,
        MEASUREMENT_WIDGET_TYPE.onlyEngagement,
      ].includes(typeMeasureWidget)
    ) {
      return null
    }
    const {
      history,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    return (
      <div className="WidgetResumeOutcomes boxShadow">
        <WidgetErrorBoundary resetKey={resetKey}>
          <WidgetListOutcomes
            showTitle
            history={history}
            measureGeneral={measureGeneral}
            idMeasure={idMeasure}
            idDivisionSelected={idDivisionSelected}
            idDivisionParent={idDivisionParent}
            selectedSegment={selectedSegment}
          />
        </WidgetErrorBoundary>
      </div>
    )
  }

  const renderWidgetResponseRateReport = () => {
    const {
      measureTotal,
      measureGeneral,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
      hasSegment,
    } = props
    return (
      <WidgetErrorBoundary resetKey={resetKey}>
        <WidgetResponseRateReport
          measureData={measureTotal}
          measureGeneral={measureGeneral}
          idMeasure={idMeasure}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
          hasSegment={hasSegment}
        />
      </WidgetErrorBoundary>
    )
  }

  const renderWidgetListDimensions = (typeMeasureWidget) => {
    if (typeMeasureWidget !== MEASUREMENT_WIDGET_TYPE.leadershipOrClimate) {
      return null
    }
    const {
      measureGeneral,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive()
    ) {
      return null
    }

    return (
      <WidgetErrorBoundary resetKey={resetKey}>
        <WidgetListDimensions
          measureGeneral={measureGeneral}
          idMeasure={idMeasure}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
      </WidgetErrorBoundary>
    )
  }

  return (
    <div className="SummaryWidgets">
      {renderWidgetResumeEnps(typeMeasureWidget)}
      {renderWidgetResumeOutcomes(typeMeasureWidget)}
      {renderWidgetListDimensions(typeMeasureWidget)}
      {renderWidgetResponseRateReport()}
    </div>
  )
}

SummaryWidgets.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  history: PropTypes.object,
  measureTotal: PropTypes.object,
  measureEngagement: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  selectedSegment: PropTypes.number,
  hasSegment: PropTypes.bool,
}

export default SummaryWidgets
